// Query parameters a Paths plan item's launch URL carries
// (backend/app/services/capability_targets.py build_launch_url). Pages read
// them to preselect what the plan pointed at. They never auto-start
// anything: the student still clicks.

// Same bound as capability_targets.QUIZ_TOPIC_MAX_CHARS.
export const PLAN_QUIZ_TOPIC_MAX_CHARS = 120;

// Longest raw value echoed back in a "couldn't find" line, so a pasted
// garbage URL cannot flood the page.
const MAX_ECHO_CHARS = 80;

// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/;

/**
 * Read one plan launch param.
 *
 * Returns { status: 'absent' } when the URL does not carry it, so the page
 * behaves exactly as before; { status: 'ok', value } for a usable value
 * (trimmed); and { status: 'invalid', echo } for a value that is present
 * but blank, too long, or not plain text, so the page can say what it
 * could not use instead of failing silently.
 */
export function readPlanParam(searchParams, name, { maxLength = 200 } = {}) {
  if (!searchParams || !searchParams.has(name)) return { status: 'absent' };
  const raw = searchParams.get(name) || '';
  const value = raw.trim();
  const echo = raw.length > MAX_ECHO_CHARS ? `${raw.slice(0, MAX_ECHO_CHARS)}…` : raw;
  if (!value || value.length > maxLength || CONTROL_CHARS.test(value)) {
    return { status: 'invalid', echo };
  }
  return { status: 'ok', value, echo };
}
